import { Component, inject, TemplateRef, ViewChild } from '@angular/core';
import { AppCommonModule } from "../../../../../components/app.common.module";
import { ModalService } from '@app/components/modal/modal.service';
import { FormGroup } from '@angular/forms';
import { BrandTemplateComponent } from "./brand-template/brand-template/brand-template.component";
import { BrandService } from './brand.service';
import { queryParamsBrand, queryParamsProducts } from '../financial-setup/model.models';
import { environment } from '@env/environment.local';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '@app/components/base/base.component';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';

@Component({
  selector: 'app-brand',
  standalone: true,
  imports: [AppCommonModule, BrandTemplateComponent],
  templateUrl: './brand.component.html',
  styleUrl: './brand.component.css'
})
export class BrandComponent  extends BaseComponent {
  @ViewChild('modalTemplate') modalTemplate!: TemplateRef<any>;
  @ViewChild('templateConfirmation') template!: TemplateRef<any>;

  form: FormGroup;
  isEdit: boolean = false;
  data: any[] = [];
  hasData: boolean = false;
  isLoading: boolean = false;
  pageSize: number = environment.pageSize;
  pageIndex: number = 1;
  total: number = 0;
  reset: boolean;
  selectedBrandData: any = null;

  searchName: any = { placeholder: 'Buscar por nombre', value: '' };
  searchCode: any = { placeholder: 'Buscar por código', value: '' };

  brandId : number;
  title: string = 'Eliminar Marca';
  subtitle: string = '';
  btn1: string = 'Cancelar';
  btn2: string = 'Eliminar';

  params: queryParamsBrand = {
    name: null,
    brandCode: null,
    enabled: null,
    pageSize: this.pageSize,
    page: this.pageIndex,
  };

  module: string = '';
  private readonly modalService = inject(ModalService);
  public readonly service = inject(BrandService);

  constructor(
    private router: ActivatedRoute,
    private menu: MenusServices,
    notification: NotificationService,
  ) {
    super(router, menu, notification);
    this.module = this.sendDataToMenu();
  }

  ngOnInit() {
    this.getList()
  }


  createForm() {
    this.modalService.component = this.modalTemplate;
    this.modalService.openModal();
  }

  openModal(type: string) {
    if (type === 'edit') {
      this.modalService.component = this.modalTemplate;
    } else if (type === 'confirmation') {
      this.modalService.component = this.template;
    }
    this.modalService.openModal();
  }

  onSaveBrand(newBrand: any) {
    this.data.push(newBrand);
    this.closeModal();
    this.getList();
  }

  updateBrand(updatedBrand: any) {
    this.closeModal();
    this.getList();
  }

  closeModal() {
    this.modalService.closeModal();
  }

  getList() {
    this.isLoading = true;
    this.service.getAllBrands(this.params).subscribe({
      next: (response) => {
        this.data = response.data;
        this.data.sort((a, b) => {
          if (a.enabled === b.enabled) {
            return a.name.localeCompare(b.name);
          }
          return a.enabled ? -1 : 1;
        });
        this.total = response.totalElements;
        this.pageIndex = response.page;
        this.hasData = response.data.length > 0;
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
      },
    });
  }


  search() {
    this.params.page = 1;
    this.getList();
  }


  edit(item: any) {
    this.selectedBrandData = item;
    this.isEdit = true;
    this.openModal('edit');
  }

  deleteBrandById(): void {
    this.isLoading = true;
    this.service.deleteBrand(this.brandId).subscribe({
      next: () => {
        this.closeModal();
        this.isLoading = true;
        this.getList();
      },
      error: (error) => {
        this.isLoading = false;
      },
    });
  }

  openModalConfirmation(item: any){
    this.brandId = item.id;
    this.subtitle = `¿Confirma la eliminación de la Marca: "${item.name}"?`;
    this.modalService.component = this.template;
    this.openModal('confirmation');
  }

  resetFilters() {
    this.reset = true;
    this.params = {
      name: null,
      brandCode: null,
      enabled: null,
      page: this.pageIndex,
      pageSize: this.pageSize,
    };
    this.getList();
  }

  filter(value: any, typeField: string) {
    switch (typeField) {
      case 'brandCode':
        this.params.brandCode = value == '' ? null : value;
        break;
      case 'name':
        this.params.name = value == '' ? null : value;
        break;

    }
  }

  handlePage(e: any) {
    this.params.page = e.pageIndex + 1;
    this.params.pageSize = e.pageSize;
    this.getList();
  }
}
